  import CreateChinaMapLine from './chinaPoints'
  let x_PI = 3.14159265358979324 * 3000.0 / 180.0;
  let PI = 3.1415926535897932384626;
  let a = 6378245.0;
  let ee = 0.00669342162296594323;
  let xinters
  const IsInChina = function(list, lat, lng){
    var inside = false;
    var prePoint = list[0];
    for(var i = 1; i < list.length; i++) {
        var nextPoint = list[i];
        if(lng > Math.min(prePoint[1], nextPoint[1]) && lng <= Math.max(prePoint[1], nextPoint[1]) && lat <= Math.max(prePoint[0], nextPoint[0]) && prePoint[1] != nextPoint[1]) {
            xinters = (lng - prePoint[1]) * (nextPoint[0] - prePoint[0]) / (nextPoint[1] - prePoint[1]) + prePoint[0];
            if(prePoint[0] == nextPoint[0] || lat <= xinters)
                inside ^= true;
        }
        prePoint = nextPoint;
    }
    return inside;
  }

  //判断点在多边形内还是外
  // function isPointInChina (lng, lat) {
  //   var pts=CreateChinaMapLine();
  //   var ply = new BMap.Polygon(pts);

  //   var pt = new BMap.Point(lng, lat);

  //   var result = BMapLib.GeoUtils.isPointInPolygon(pt, ply);
    
  //   // if (result == true) {
  //   //     alert("点在中国内");
  //   // } else {
  //   //     alert("点在中国外")
  //   // }
  //   return result
  // }

  //判断点在多边形内还是外
  function out_of_china (lng, lat) {
    var pts=CreateChinaMapLine();
    var ply = new BMap.Polygon(pts);

    var pt = new BMap.Point(lng, lat);

    var result = BMapLib.GeoUtils.isPointInPolygon(pt, ply);
    
    // if (result == true) {
    //     alert("点在中国内");
    // } else {
    //     alert("点在中国外")
    // }
    // console.log(result ? 'in china' : 'out of china')
    return !result
  }

  /**
   * 判断是否在国内，不在国内则不做偏移
   * @param lng
   * @param lat
   * @returns {boolean}
   */
  // function out_of_china(lng, lat) {
  //     lat = +lat;
  //     lng = +lng;
  //     // 纬度3.86~53.55,经度73.66~135.05
  //     return !(lng > 73.66 && lng < 135.05 && lat > 17 && lat < 53.55);
  // }

  function transformlat(lng, lat) {
      lat = +lat;
      lng = +lng;
      var ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
      ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0;
      ret += (20.0 * Math.sin(lat * PI) + 40.0 * Math.sin(lat / 3.0 * PI)) * 2.0 / 3.0;
      ret += (160.0 * Math.sin(lat / 12.0 * PI) + 320 * Math.sin(lat * PI / 30.0)) * 2.0 / 3.0;
      return ret
  }

  function transformlng(lng, lat) {
      lat = +lat;
      lng = +lng;
      var ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
      ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0;
      ret += (20.0 * Math.sin(lng * PI) + 40.0 * Math.sin(lng / 3.0 * PI)) * 2.0 / 3.0;
      ret += (150.0 * Math.sin(lng / 12.0 * PI) + 300.0 * Math.sin(lng / 30.0 * PI)) * 2.0 / 3.0;
      return ret
  }

  export var TransForm = {

  /**
   * 百度坐标系 (BD-09) 与 火星坐标系 (GCJ-02)的转换
   * 即 百度 转 谷歌、高德
   * @param bd_lon
   * @param bd_lat
   * @returns {*[]}
   */
  bd09togcj02 : function bd09togcj02(bd_lon, bd_lat) {
    bd_lon = +bd_lon;
    bd_lat = +bd_lat;
    var x = bd_lon - 0.0065;
    var y = bd_lat - 0.006;
    var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_PI);
    var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_PI);
    var gg_lng = z * Math.cos(theta);
    var gg_lat = z * Math.sin(theta);
    return [gg_lng, gg_lat]
  },

  /**
   * 火星坐标系 (GCJ-02) 与百度坐标系 (BD-09) 的转换
   * 即谷歌、高德 转 百度
   * @param lng
   * @param lat
   * @returns {*[]}
   */
  gcj02tobd09 : function gcj02tobd09(lng, lat) {
    lat = +lat;
    lng = +lng;
    if (out_of_china(lng, lat)) {
      return [lng, lat]
    } else {
      var z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_PI);
      var theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI);
      var bd_lng = z * Math.cos(theta) + 0.0065;
      var bd_lat = z * Math.sin(theta) + 0.006;
      return [bd_lng, bd_lat]
    }
  },

  wgs84tobd09: function wgs84ToBd09(lng, lat) {
      var tmp = this.wgs84togcj02(lng, lat);
      tmp = this.gcj02tobd09(tmp[0], tmp[1]);
      return tmp;
  },

  /**
   * WGS84转GCj02
   * @param lng
   * @param lat
   * @returns {*[]}
   */
  wgs84togcj02 : function wgs84togcj02(lng, lat) {
    lat = +lat;
    lng = +lng;
    if (out_of_china(lng, lat)) {
      return [lng, lat]
    } else {
      var dlat = transformlat(lng - 105.0, lat - 35.0);
      var dlng = transformlng(lng - 105.0, lat - 35.0);
      var radlat = lat / 180.0 * PI;
      var magic = Math.sin(radlat);
      magic = 1 - ee * magic * magic;
      var sqrtmagic = Math.sqrt(magic);
      dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI);
      dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI);
      var mglat = lat + dlat;
      var mglng = lng + dlng;
      return [mglng, mglat]
    }
  },

  /**
   * GCJ02 转换为 WGS84
   * @param lng
   * @param lat
   * @returns {*[]}
   */
  gcj02towgs84 : function gcj02towgs84(lng, lat) {
    lat = +lat;
    lng = +lng;
    if (out_of_china(lng, lat)) {
      return [lng, lat]
    } else {
      var dlat = transformlat(lng - 105.0, lat - 35.0);
      var dlng = transformlng(lng - 105.0, lat - 35.0);
      var radlat = lat / 180.0 * PI;
      var magic = Math.sin(radlat);
      magic = 1 - ee * magic * magic;
      var sqrtmagic = Math.sqrt(magic);
      dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI);
      dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI);
      var mglat = lat + dlat;
      var mglng = lng + dlng;
      return [lng * 2 - mglng, lat * 2 - mglat]
    }
  },
  }
